import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    outerGrid: 'lg:px-6',
    outerGridWrapper: ''
  },
  grid: {
    gaps: {
      x: 'xs',
      y: 'sm'
    }
  }
} satisfies RecursivePartial<ProductConfig['list']>
